import * as request from '../../request'

export const getAll = (params) => request.get('v1/superviseds', { params })

export const getDetail = (stdCode) => request.get(`v1/superviseds/${stdCode}`)

export const getWalletSupervised = (stdCode, params) =>
  request.get(`v1/superviseds/${stdCode}/wallets`, {
    params: { ...params, perPage: 9 }
  })

export default {
  getAll,
  getDetail,
  getWalletSupervised
}
